import { ButtonBase, Trash } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  ImmutableTextPreset,
  makePresetSelector,
} from 'redux/modules/text-presets';

import { block } from './utils';

interface TextPresetButtonProps {
  isSelected: boolean;
  mode: 'horizontal' | 'vertical';
  onClick: (presetStyles: ImmutableTextPreset) => void;
  onDelete: (textPresetId: string) => void;
  presetId: string;
}

const TextPresetButton: React.FunctionComponent<TextPresetButtonProps> = props => {
  const { isSelected, mode, onClick, onDelete, presetId } = props;

  const preset = useSelector(makePresetSelector(presetId));

  const handleClickPreset = React.useCallback(() => {
    onClick(preset);
  }, [onClick, preset]);

  const handleDeletePreset = React.useCallback(() => {
    onDelete(preset?.get('textPresetId'));
  }, [onDelete, preset]);

  if (!preset || !preset.get('previewImageUrl')) {
    return null;
  }

  return (
    <div className={block('text-preset-button')}>
      <ButtonBase
        className={block('main-button', { [mode]: true, selected: isSelected })}
        onPress={handleClickPreset}
      >
        <img
          className={block('preset-preview', {
            [mode]: true,
            selected: isSelected,
          })}
          src={preset.get('previewImageUrl')}
          alt="Text preset preview"
        />
      </ButtonBase>

      {preset.get('canDelete') && (
        <ButtonBase
          className={block('delete-button')}
          onPress={handleDeletePreset}
        >
          <Trash />
        </ButtonBase>
      )}
    </div>
  );
};

export default TextPresetButton;
